import React from 'react';
import { isMobile } from 'react-device-detect';
import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';

export default {

	destroy(controller) {
		controller.destroy(true);
	},

	initialise(container) {
		this.controller = new ScrollMagic.Controller();
		if (isMobile) {
			return this.controller;
		}

		this.features(container);
		this.speechBubbles(container);
		this.services(container);

		return this.controller;
	},
	
	features(container) {
		let tl = new TimelineLite(),
			imgBanter = container.querySelector('.voip-features .banter'),
			imgByExetel = container.querySelector('.voip-features .by-exetel'),
			features = [...container.getElementsByClassName('feature-item')];
		
		features.sort(() => {
			return 0.5-Math.random();
		});

		tl.fromTo(imgBanter, 0.25, {width: 0, height: 0}, {width: '280px', height: 'auto'});
		tl.fromTo(imgByExetel, 0.25, {width: 0, height: 0}, {width: '322px', height: 'auto', delay: 0.2});
		tl.staggerFromTo(features, 0.3, {opacity: 0, scale: 0.5}, {opacity: 1, scale: 1, ease: Power1.easeOut}, 0.1);

		new ScrollMagic.Scene({
			triggerElement: '.voip-features',
			offset: 100,
			reverse: false
		})
			.setTween(tl)
			.addTo(this.controller);
	},

	speechBubbles(container) {
		let tl = new TimelineLite(),
			speechBubbles = [...container.querySelectorAll('.cubes .banter-heading .overflow')];

		speechBubbles.forEach(item => {
			if (item.classList.contains('point-left')) {
				tl.fromTo(item, 0.25, {x: '-100%', y: '100%', scale: 0}, {x: '0%', y: '0%', scale: 1}, '-=0.1');
			} else {
				tl.fromTo(item, 0.25, {x: '100%', y: '100%', scale: 0}, {x: '0%', y: '0%', scale: 1}, '-=0.1');
			}
		});

		new ScrollMagic.Scene({
			triggerElement: '.cubes-module',
			offset: 300,
			reverse: false
		})
			.setTween(tl)
			.addTo(this.controller);
	},

	services(container) {
		let tl = new TimelineLite(),
			speechBubbles = [...container.querySelectorAll('.twin-column .banter-heading .overflow')];

		tl.staggerFromTo(speechBubbles, 0.25, {x: '100%', y: '100%', scale: 0}, {x: '0%', y: '0%', scale: 1}, 0.2);

		new ScrollMagic.Scene({
			triggerElement: '.twin-column',
			offset: 200,
			reverse: false
		})
			.setTween(tl)
			.addTo(this.controller);
	}

}


// WEBPACK FOOTER //
// ./resources/assets/js/voip/UnifiedCommunications/animations.js